import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getInvoice(interval, start, end) {
    var url = API_ENDPOINT + "invoice/get/" + getToken() + "?interval=" + interval + "&start=" + start + "&end=" + end;
    const res = await fetch(url);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getTopInvoice() {
    const res = await fetch(API_ENDPOINT + "invoice/get/top/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getInvoiceByClient(client, interval, start, end) {
    var url = API_ENDPOINT + "invoice/get/" + getToken() + "?interval=" + interval + "&start=" + start + "&end=" + end + "&client=" + client;
    const res = await fetch(url);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getInvoiceDetails(invoice) {
    var url = API_ENDPOINT + "invoice/get/" + invoice + "/" + getToken();
    const res = await fetch(url);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function payFullInvoice(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "transaction/invoice-payment", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function paidClinet(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "transaction/client-cash-payment", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getInvoiceAiAnalysis(invoice) {
    var url = API_ENDPOINT + "quotation/validate-invoice/" + invoice + "/" + getToken();
    const res = await fetch(url);
    if (res.status === 200)
        return { "code": 200, "body": await res.json() };
    if (res.status === 202)
        return { "code": 202, "body": await res.json() };
    throw await res.json();
}
